<template>
  <div :style="aStyle">
    <!-- {{ data }} -->
    <!-- {{ image }} -->
    <v-img
      v-if="image && image != 'null'"
      :src="image"
      :width="imageWidth"
      :height="imageHeight"
      :position="imagePosition"
      :contain="contain"
      :class="imageClass ? imageClass : aClass"
    ></v-img>
    <v-icon
      v-else-if="icon"
      :color="iconColor"
      :x-small="iconSize == 'x-small'"
      :class="iconClass ? iconClass : aClass"
    >
      mdi-{{ icon }}</v-icon
    >
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "IconOrImage",
  props: {
    data: null,
    imagePath: null,
    imageWidth: { type: Number, default: 30 },
    imageHeight: { type: Number, default: 30 },
    imagePosition: { type: String, default: "center center" },
    contain: { type: Boolean, default: true },
    iconSize: { type: String, default: "small" }, // small, x-small, etc
    iconColor: { type: String, default: "primary" },
    imageClass: null,
    iconClass: null,
    aClass: { type: String, default: "mr-2" },
    imageKey: { type: String, default: "image" }, // may be "img"?
    aStyle: null,
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    icon: function () {
      let rtn = null;
      if (this.data.icon && this.data.icon != "") rtn = this.data.icon;
      return rtn;
    },
    image: function () {
      let rtn = null;
      if (this.data[this.imageKey] && this.data[this.imageKey] != "")
        rtn = this.data[this.imageKey];
      //   console.log(rtn);
      if (rtn && this.imagePath) rtn = this.imagePath + rtn;
      //   console.log(rtn);
      return rtn;
    },
  },
};
</script>

<style scoped></style>
